import React, { useMemo, useState } from 'react';
import { Box, Checkbox, FormControlLabel, makeStyles } from '@material-ui/core';
import _ from 'lodash';
import { i18n } from '../../../../../../language';
import { getArrayRandomKey } from '../../../../../../utils';
import IndividualUserDialog from '../../../IndividualUserDialog';

const useStyles = makeStyles((theme) => ({
  notifyBox: {
    paddingTop: '1.428rem',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gridGap: '1.714rem',
    borderTop: '0.0625rem solid #ddd',
    flexWrap: 'wrap',
  },
  groupBox: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'NotoSans-Medium',
    color: '#2E4469',
    gridGap: '0.5rem',
  },
  inputBox: {
    padding: '0.642rem 0.857rem',
    borderRadius: '0.714rem',
    border: '1px solid #E4E7EB',
    height: '2.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gridGap: '1rem',
    cursor: 'pointer',
    width: '25rem',
  },
  groupName: {
    fontSize: '1.142rem',
    fontWeight: 500,
    color: '#2E4469',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  editBtn: {
    fontSize: '1.142rem',
    fontWeight: 500,
    color: '#538FFF',
  },
  checkBox: {
    marginLeft: '0rem',
    '& .MuiButtonBase-root': {
      padding: '0',
      paddingRight: '0.5rem',
    },
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1.142rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
}));

export default function Notify({ templateInfo, handleChangeTemplate, individualUserOptions }) {
  const { notifyList, sendToList, notifyBaseOnSendTo } = templateInfo;
  const classes = useStyles();
  const [showNotifyListDialog, setShowNotifyListDialog] = useState(false);
  const needNotifyItems = [
    {
      label: i18n.t('EHANDOVER_ITEM_COMPLETE'),
      type: 'ITEM_COMPLETE',
    },
    {
      label: i18n.t('EHANDOVER_CHECKLIST_COMPLETE'),
      type: 'CHECKLIST_COMPLETE',
    },
  ];
  const checkedMapping = {
    ITEM_COMPLETE: 'itemComplete',
    CHECKLIST_COMPLETE: 'checklistComplete',
  };
  const notifyDisplayName = useMemo(() => {
    const roomTypeDisplayName = _.map(notifyList.roomTypeList, (item) => item?.name);
    const staffDisplayName = _.map(notifyList.staffList, (item) => item?.staffName);

    if (roomTypeDisplayName.length !== 0 || staffDisplayName.length !== 0) {
      return [...roomTypeDisplayName, ...staffDisplayName].join(',');
    } else {
      return '';
    }
  }, [notifyList]);

  const handleConfirmIndividual = ({ selectedRoom, selectedStaff }) => {
    handleChangeTemplate('notifyList', { roomTypeList: selectedRoom, staffList: selectedStaff });
    setShowNotifyListDialog(false);
  };
  const handleUpdateBaseOnSendTo = (checked) => {
    handleChangeTemplate('notifyBaseOnSendTo', checked);
  };

  return (
    <>
      <Box className={classes.notifyBox}>
        <Box display="flex" flexDirection="row" alignItems="center" gridGap="0.857rem">
          <Box fontSize="1.142rem" fontWeight="500" fontFamily="NotoSans-Medium">
            {i18n.t('EHANDOVER_NOTIFY')}:
          </Box>
          <Box className={classes.groupBox}>
            <Box className={classes.inputBox} style={{ width: '30rem' }} onClick={() => setShowNotifyListDialog(true)}>
              <Box className={classes.groupName}>
                {notifyDisplayName ? (
                  notifyDisplayName
                ) : (
                  <Box color="rgb(125, 134, 169)" fontSize="1rem">
                    {i18n.t('EHANDOVER_SELECT')}
                  </Box>
                )}
              </Box>
              <Box className={classes.editBtn}>{i18n.t('EHANDOVER_EDIT')}</Box>
            </Box>
          </Box>
        </Box>
        <Box display="flex" flexDirection="row" alignItems="center" gridGap="0.857rem">
          <Box fontSize="1.142rem" fontWeight="500" fontFamily="NotoSans-Medium">
            {i18n.t('EHANDOVER_WHEN')}
          </Box>
          {_.map(needNotifyItems, (item, index) => (
            <FormControlLabel
              key={getArrayRandomKey(index, 'ehandover-notify')}
              control={<Checkbox />}
              label={item.label}
              className={classes.checkBox}
              checked={templateInfo?.[checkedMapping?.[item.type]]}
              onChange={(event) => handleChangeTemplate(checkedMapping?.[item.type], event.target.checked)}
            />
          ))}
        </Box>
      </Box>
      {showNotifyListDialog && (
        <IndividualUserDialog
          open={showNotifyListDialog}
          closePop={() => setShowNotifyListDialog(false)}
          roomTypeList={notifyList?.roomTypeList}
          staffList={notifyList?.staffList}
          individualUsers={individualUserOptions}
          handleConfirm={handleConfirmIndividual}
          notifyParam={{
            notifyBaseOnSendTo,
            setNotifyBaseOnSendTo: handleUpdateBaseOnSendTo,
            sendToRoomTypeList: sendToList?.roomTypeList,
            sendToStaffList: sendToList?.staffList,
          }}
        />
      )}
    </>
  );
}
